import { useMatches } from '@tanstack/react-router'
import _ from 'lodash'
import { useEffect } from 'react'

import { useSearchParamsStore } from '@/store/searchParams/searchParams'

import { UseCacheSearchParamsOptions } from './types'

export const useCacheSearchParams = ({
  routeSearchParamsToCache,
}: UseCacheSearchParamsOptions) => {
  const matches = useMatches()
  const setSearchParams = useSearchParamsStore(state => state.setSearchParams)

  useEffect(() => {
    const currentMatch = matches[matches.length - 1]
    const searchParamsToCache = routeSearchParamsToCache[currentMatch.routeId]
    if (searchParamsToCache) {
      const routeSearch = currentMatch.search
      const filteredSearch =
        searchParamsToCache === true
          ? routeSearch
          : _.pick(routeSearch, searchParamsToCache)

      setSearchParams({
        to: currentMatch.routeId,
        search: filteredSearch,
      })
    }
  }, [matches, routeSearchParamsToCache, setSearchParams])
}
